"use client"

import { Box, Typography } from "@mui/material"
import axios from "axios"
import moment from "moment"
import { saveAs } from "file-saver"
import htmlDocx from "html-docx-js/dist/html-docx"
import { PrimaryButton } from "components/Buttons"
import { showPromiseToast } from "components/NewToaster"
import { ErrorToaster } from "components/Toaster"
import instance from "config/axios"
import CustomerServices from "services/Customer"
import routes from "services/System/routes"
import { agencyType, CleanTypes, getFileSize } from "utils"
import { useRef, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { Images } from "assets"


const ExpCertificate = () => {
    const contentRef = useRef(null)
    const { state } = useLocation()
    const navigate = useNavigate()
    const [progress, setProgress] = useState(0)
    const [uploadedSize, setUploadedSize] = useState(0)
    const [loading, setLoading] = useState(false)

    // Function to convert image to base64
    const getImageAsBase64 = (url) => {
        return new Promise((resolve, reject) => {
            const img = new Image()
            img.crossOrigin = "anonymous"
            img.onload = () => {
                const canvas = document.createElement("canvas")
                const ctx = canvas.getContext("2d")
                canvas.width = img.width
                canvas.height = img.height
                ctx.drawImage(img, 0, 0)
                const dataURL = canvas.toDataURL("image/png")
                resolve(dataURL)
            }
            img.onerror = reject
            img.src = url
        })
    }

    console.log(state)

    const allowFilesType = ["application/pdf"]

    // *For Upload Document
    const handleUploadDocument = async (e) => {
        try {
            e.preventDefault()
            const file = e.target.files[0]
            const arr = [
                {
                    name: file?.name,
                    file: "",
                    type: file?.type.split("/")[1],
                    size: getFileSize(file.size),
                    isUpload: false,
                },
            ]
            if (allowFilesType.includes(file.type)) {
                handleUpload(file, arr)
                const path = await handleUpload(file, arr)
                console.log("Uploaded file path:", path)
                console.log(path, "pathpathpath")
                return path
            } else {
                ErrorToaster(`Only ${CleanTypes(allowFilesType)} formats is supported`)
            }
        } catch (error) {
            ErrorToaster(error)
        }
    }

    const handleUpload = async (file, docs) => {
        setProgress(0)
        try {
            const formData = new FormData()
            formData.append("document", file)
            console.log(formData)
            const { data } = await instance.post(routes.uploadDocuments, formData, {
                onUploadProgress: (progressEvent) => {
                    const uploadedBytes = progressEvent.loaded
                    const percentCompleted = Math.round((uploadedBytes * 100) / progressEvent.total)
                    setProgress(percentCompleted)
                    console.log(getFileSize(uploadedBytes))
                    setUploadedSize(getFileSize(uploadedBytes))
                },
            })
            if (data) {
                docs[0].isUpload = true
                docs[0].file = data?.data?.nations
                console.log(data, "asddasasd")
                return data?.data?.path
            }
        } catch (error) {
            ErrorToaster(error)
        }
    }
    console.log(state, 'state');

    const createCertificate = async (path) => {
        setLoading(true)
        try {
            const obj = {
                type: "experience",                //"experience"
                reference_number: state?.reference,
                to: state?.to,
                forField: state?.for,
                employee_id: state?.user_id,
                content: '12'
            }
            console.log(obj)
            const promise = CustomerServices.CreateCertificate(obj)
            showPromiseToast(promise, "Saving ...", "Success", "Something Went Wrong")
            const response = await promise
            if (response?.responseCode === 200) {
                navigate("/experience-certificate")
            }
        } catch (error) {
            console.error("Error creating certificate:", error)
        } finally {
            setLoading(false)
        }
    }

    const sendBlobPreview = async (base64, name) => {
        const obj = {
            document: base64,
            filename: name,
        }
        try {
            const response = await axios.post(process.env.REACT_APP_BASE_URL + "/system/uploadDocumentsBase64", obj)
            console.log("Upload successful:", response.data.data.path)
            createCertificate(response?.data?.data?.path)
        } catch (error) {
            console.error("Error uploading the file:", error)
        }
    }

    const exportDOCWithMethod = async () => {
    const refNumber = `HR-01-SC-${moment().format("DDMM")}-${moment().format("MM-YYYY")}`;
    const currentDate = moment().format("D MMM YYYY");
    const fileName = `${state?.user?.name}-ExperienceCertificate.docx`;

    // Convert logo to base64
    let logoBase64 = "";
    try {
        logoBase64 = await getImageAsBase64(
            agencyType[process.env.REACT_APP_TYPE]?.category === "TASHEEL"
                ? Images.tasheel
                : Images.aldeed
        );
    } catch (error) {
        console.error("Error converting logo to base64:", error);
        logoBase64 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==";
    }

    // Optimized HTML
    const htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
        <meta charset="utf-8" />
        <title>Experience Certificate</title>
        <style>
            @page {
                size: A4;
                margin: 2cm;
            }
            body {
                font-family: 'Times New Roman', serif;
                line-height: 1.4;
                font-size: 11pt;
                margin: 0 auto;
                padding: 0;
                max-width: 800px;
            }
            .header {
                text-align: center;
                margin-bottom: 20px;
                border-bottom: 1px solid #000;
                padding-bottom: 10px;
            }
            .logo {
                width: 70px;
                height: 70px;
                margin: 0 auto 15px;
            }
            .ref-section, .to-section, .content {
                margin: 15px 0;
            }
            .certificate-title {
                text-align: center;
                font-size: 13pt;
                font-weight: bold;
                text-decoration: underline;
                margin: 25px 0;
            }
            .content {
                text-align: justify;
                font-size: 11pt;
            }
            .employee-details {
                font-weight: bold;
            }
            .underline {
                text-decoration: underline;
            }
            .signature-section {
                margin-top: 40px;
                font-size: 11pt;
            }
            .signature-line {
                margin-top: 30px;
                border-bottom: 1px solid #000;
                width: 200px;
            }
            .footer {
                margin-top: 30px;
                padding-top: 10px;
                border-top: 1px solid #000;
                font-size: 9pt;
                text-align: center;
                color: #666;
            }
        </style>
    </head>
    <body>
        <div class="header">
            <img src="${logoBase64}" alt="Company Logo" class="logo" />
        </div>

        <div class="ref-section">
            <div>Ref: ${state?.reference || state?.reference_number}</div>
            <div>Date: ${currentDate}</div>
        </div>

        <div class="to-section">
            <strong>To,</strong><br/>
            ${state?.to}<br/>
            UAE
        </div>

        <div class="certificate-title">EXPERIENCE CERTIFICATE</div>

        <div class="content">
            <p>
                This is to certify that, <span class="employee-details underline">${state?.user?.name || state?.employee?.name}</span>,
                passport no. <span class="employee-details">${state?.passport_number || "-"}</span>, was working in the capacity of
                <span class="employee-details">${state?.designation}</span> in our esteemed organization from
                <span class="employee-details">${moment(state?.date_of_joining).format('DD-MMMM-YYYY')}</span> to
                <span class="employee-details">${moment(state?.valid_till).isSame(moment(), 'day') ? 'Present' : moment(state?.valid_till).format('DD-MMMM-YYYY')}</span>.
                During his/her tenure, he/she has shown dedication, professionalism and commitment to his/her duties.
            </p>
            <p>
                We found him/her to be honest, hardworking and of good conduct. We wish him/her all the best in his/her future endeavors.
            </p>
        </div>

        <div><strong>${state?.for || ''}</strong></div>

        <div class="signature-section">
            <p><strong>Authorized Signatory</strong></p>
            <p><strong>Human Resources Department</strong></p>
            <div class="signature-line"></div>
            <p style="margin-top: 10px;">Date: ${currentDate}</p>
        </div>

        <div class="footer">
            <table style="width: 100%; border-collapse: collapse;">
                <tr>
                    <td style="width: 33%; text-align: left;">www.premiumservices.ae</td>
                    <td style="width: 34%; text-align: center;">
                        ${agencyType[process.env.REACT_APP_TYPE]?.category === "TASHEEL"
                            ? "Premium Businessmen Services"
                            : "For Premium Professional Government Services L.L.C."}<br/>
                        P.O. Box 334338, UAE<br/>
                        Telephone: +971 4 520 4444
                    </td>
                    <td style="width: 33%; text-align: right; direction: rtl;">
                        بريميم بروفيشنال الخدمات الحكومية<br/>
                        ش.ذ.م.م ص.ب 334338<br/>
                        الإمارات العربية المتحدة<br/>
                        هاتف: 4444 520 4 971+
                    </td>
                </tr>
            </table>
        </div>
    </body>
    </html>
    `;

    const converted = htmlDocx.asBlob(htmlContent);
    saveAs(converted, fileName);

    const reader = new FileReader();
    reader.onload = () => {
        const base64 = reader.result.split(",")[1];
        sendBlobPreview(base64, `${state?.user?.name}_Experience_Certificate`);
    };
    reader.readAsDataURL(converted);
};


    return (
        <>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2, p: 3 }}>
                <Box sx={{ display: "flex", gap: "10px" }}>
                    <PrimaryButton
                        bgcolor={"#001f3f"}
                        title="Save"
                        onClick={() => {
                            exportDOCWithMethod()
                        }}
                        disabled={loading}
                    />
                </Box>
            </Box>

            <Box
                ref={contentRef}
                component={"div"}
                id="doc"
                sx={{
                    backgroundColor: "white",
                    color: "black",
                    padding: 4,
                    border: "1px solid #ddd",
                    borderRadius: 2,
                    maxWidth: 800,
                    margin: "0 auto",
                    marginTop: 3,
                    fontFamily: "Times New Roman, serif",
                }}
            >
                {/* Header Section */}
                <Box sx={{ textAlign: "center", mb: 4, pb: 2 }}>
                    <Box sx={{ mb: 2 }}>
                        <img
                            src={agencyType[process.env.REACT_APP_TYPE]?.category === "TASHEEL" ? Images.tasheel : Images.aldeed}
                            alt="Company Logo"
                            style={{
                                width: "150px",
                                height: "150px",
                                display: "block",
                                margin: "0 auto",
                            }}
                        />
                    </Box>

                </Box>

                {/* Reference Section */}
                <Box sx={{ mb: 3 }}>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                        Ref: {state?.reference || state?.reference_number}
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 2 }}>
                        Date: {moment().format("D MMM YYYY")}
                    </Typography>
                </Box>

                {/* To Section */}
                <Box sx={{ mb: 3 }}>
                    <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
                        To,
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 0.5 }}>
                        {state?.to}
                    </Typography>
                    <Typography variant="body2">UAE</Typography>
                </Box>

                {/* Certificate Title */}
                <Typography
                    variant="h6"
                    align="center"
                    sx={{
                        textDecoration: "underline",
                        fontWeight: "bold",
                        my: 4,
                    }}
                >
                    EXPERIENCE CERTIFICATE
                </Typography>

                {/* Main Content */}
                <Box sx={{ textAlign: "justify", mb: 3 }}>
                    <Typography paragraph sx={{ fontSize: "0.95rem", lineHeight: 1.6 }}>
                        This is to certify that,{" "}
                        <span style={{ textDecoration: "underline", fontWeight: "bold" }}>{state?.user?.name || state?.employee?.name}</span>,
                        passport no. <span style={{ fontWeight: "bold" }}>{state?.passport_number || "-"}</span>, was working in the
                        capacity of <span style={{ fontWeight: "bold" }}>{state?.designation}</span> in our esteemed organization from{" "}
                        <span style={{ fontWeight: "bold" }}>{moment(state?.date_of_joining).format('DD-MMMM-YYYY')}</span> to{" "}
                        <span style={{ fontWeight: "bold" }}>{moment(state?.valid_till).isSame(moment(), 'day')
                            ? 'Present'
                            : moment(state?.valid_till).format('DD-MMMM-YYYY')}
                        </span>. During his/her tenure, he/she has shown dedication,
                        professionalism and commitment to his/her duties.
                    </Typography>

                    <Typography paragraph sx={{ fontSize: "0.95rem", lineHeight: 1.6 }}>
                        We found him/her to be honest, hardworking and of good conduct. We wish him/her all the best in his/her
                        future endeavors.
                    </Typography>
                </Box>

                <Typography paragraph sx={{ fontWeight: "bold", mt: 3 }}>

                    {state?.for}

                </Typography>

                {/* Signature Section */}
                <Box sx={{ mt: 6 }}>
                    <Typography sx={{ fontWeight: "bold", mb: 1 }}>Authorized Signatory</Typography>
                    <Typography sx={{ fontWeight: "bold", mb: 4 }}>Human Resources Department</Typography>
                    <Box sx={{ borderBottom: "1px solid #000", width: "200px", mb: 1 }}></Box>
                    <Typography variant="body2">Date: {moment().format("D MMM YYYY")}</Typography>
                </Box>

                {/* Footer */}
                <Box
                    sx={{
                        mt: 6,
                        borderTop: "2px solid #000",
                        pt: 2,
                        fontSize: "0.8rem",
                        color: "#666",
                    }}
                >
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <Box sx={{ flex: 1, textAlign: "left" }}>
                            <Typography variant="body2">www.premiumservices.ae</Typography>
                        </Box>
                        <Box sx={{ flex: 1, textAlign: "center" }}>
                            <Typography variant="body2" sx={{ mb: 0.5 }}>
                                {agencyType[process.env.REACT_APP_TYPE]?.category === "TASHEEL"
                                    ? "Premium Businessmen Services"
                                    : 'For Premium Professional Government Services L.L.C.'}

                            </Typography>
                            <Typography variant="body2" sx={{ mb: 0.5 }}>
                                Services L.L.C P.O. Box 334338, United Arab Emirates
                            </Typography>

                            <Typography variant="body2">Telephone: +971 4 520 4444</Typography>
                        </Box>
                        <Box sx={{ flex: 1, textAlign: "right", direction: "rtl" }}>
                            <Typography variant="body2" sx={{ mb: 0.5 }}>
                                بريميم بروفيشنال الخدمات الحكومية
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 0.5 }}>
                                ش.ذ.م.م ص.ب 334338
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 0.5 }}>
                                في الإمارات العربية المتحدة
                            </Typography>
                            <Typography variant="body2">هاتف: 4444 520 4 971+</Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    )
}

export default ExpCertificate
